import { requestPost } from '@/common/request';

export interface updateChannelParams {
  channelId: string;
  name: string;
  remark: string;
  online: number;
  linkType?: number;
  link?: string;
  pic?: string;
  parentChannelId?: string;
  channelType?: number;
  towerIds?: string;
  channelTag?: number;
  onlineOperat: number;
  channelAchieve: number;
  merchantLink?: string;
  operationLink?: string;
}

export interface updateChannelRes {
  ret: string;
  msg: string;
  data: {};
}

export async function updateChannel(params: updateChannelParams): Promise<updateChannelRes> {
  return await requestPost('/channelActivity/updateChannel', params);
}
